import React from 'react';
import { useTranslation } from 'react-i18next';
import { GB, IT, ES, DE, FR, PT } from 'country-flag-icons/react/3x2';

const languages = [
  { code: 'en', name: 'English', icon: GB },
  { code: 'it', name: 'Italiano', icon: IT },
  { code: 'es', name: 'Español', icon: ES },
  { code: 'de', name: 'Deutsch', icon: DE },
  { code: 'fr', name: 'Français', icon: FR },
  { code: 'pt', name: 'Português', icon: PT },
];

function Navbar() {
  const { i18n } = useTranslation();

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
  };

  return (
    <nav className="bg-[#b7e9f7] p-4 w-full fixed top-0 border-2 border-[#1f7bbf]">
      <div className="container mx-auto flex flex-row justify-between">
        <div className="flex items-center">
        <select
            onChange={(e) => handleLanguageChange(e.target.value)}
            className="bg-white text-black font-bold border-none outline-none p-2 rounded-md"
            defaultValue={i18n.language}
          >
            {languages.map((lang) => (
              <option key={lang.code} value={lang.code}>
                <span className="inline-block mr-2">
                  <lang.icon className="w-6 h-4 inline-block"  />
                </span>
                {lang.name}
              </option>
            ))}
          </select>
        </div>
        <div></div>      
      </div>
    </nav>
  );
}

export default Navbar;
